import { useEffect, useRef, useState } from "react";

const useScrollHandler = (activeStep, cardWidthPercent = 70, cardMargin = 4, cardMaxWidth = 250) => {
  const scrollableContainerRef = useRef(null);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  useEffect(() => {
    if (scrollableContainerRef.current) {
      const containerWidth = scrollableContainerRef.current.clientWidth;
      const cardWidth = Math.min(
        (cardWidthPercent / 100) * containerWidth,
        cardMaxWidth
      );
      const scrollPosition = activeStep * (cardWidth + cardMargin * 2);
      scrollableContainerRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth"
      });
    }
  }, [activeStep]);

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStartX !== null && touchEndX !== null && scrollableContainerRef.current) {
      const containerWidth = scrollableContainerRef.current.clientWidth;
      const cardWidth = Math.min((cardWidthPercent / 100) * containerWidth, cardMaxWidth);
      const distance = touchStartX - touchEndX;
      const scrollAmount = Math.sign(distance) * (cardWidth + cardMargin * 2);
      scrollableContainerRef.current.scrollLeft += scrollAmount;
    }
    setTouchStartX(null);
    setTouchEndX(null);
  };

  return {
    scrollableContainerRef,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd
  };
};

export default useScrollHandler;